import { AngleRight, Link } from '@/client/components/icons/ContinuIcons';
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewAssignmentModal() {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  useEffect(() => {
    const isInstance = location.pathname.includes('instance');

    if (!isInstance && !id) {
      onOpen();
    }
  }, [location]);

  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent padding={2}>
        <ModalBody marginBottom={10}>
          <Box
            height={272}
            width="full"
            backgroundColor="brand.primary"
            backgroundImage="url(/public/images/new-assignment.jpg)"
            animation="fadeIn 1s ease-in"
            sx={{
              '@keyframes fadeIn': {
                '0%': { opacity: 0 },
                '100%': { opacity: 1 },
              },
            }}
            backgroundSize="cover"
          />

          <VStack textAlign="center" marginY={10}>
            <Text fontSize="24px" fontWeight={600}>
              {t('admin.assignments.newAssignmentModal.heading')}
            </Text>

            <Text fontSize="16px" fontWeight="600" color="neutral.600">
              {t('admin.assignments.newAssignmentModal.description')}
            </Text>
          </VStack>

          <Flex
            backgroundColor="neutral.0"
            padding={4}
            justifyContent="space-between"
            alignItems="center"
            borderRadius="8px"
            _hover={{ cursor: 'pointer' }}
            onClick={() => {
              window.open(
                'https://help.continu.com/hc/en-us/articles/32642640689175-Updated-Assignments-Article-Video-Hub',
                '_blank',
              );
            }}
          >
            <HStack>
              <Icon as={Link} />

              <Text fontSize="14px" fontWeight={600}>
                {t('admin.assignments.newAssignmentModal.readMore')}
              </Text>
            </HStack>

            <Icon as={AngleRight} />
          </Flex>
        </ModalBody>

        <ModalFooter display="flex" justifyContent="center">
          <ButtonGroup gap={4}>
            <Button variant="createCancel" onClick={() => navigate('/admin/assignments/overview')}>
              {t('global.actions.cancel')}
            </Button>

            <Button variant="solid" onClick={onClose}>
              {t('admin.assignments.newAssignmentModal.getStarted')}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
